/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'
import { cmsMessagesEn } from 'isotope-client-cms'

export default flatten({
    isotope: {
        datatable: {
            header: {
                selected: '{numSelected, plural, =0 {ANG - Aucun élément sélectionné} one {ANG - 1 élément sélectionné} other {# ANG - éléments sélectionnés}}'
            },
            footer: {
                elementsPerPage: 'ANG - Éléments par page :',
                pagination: 'ANG - {startIndex, number} - {endIndex, number} sur {total, number}'
            }
        }
    },
    cms: {
        ...cmsMessagesEn,
        entities: {
            tenderbox: 'Modification of the Tender Box presentation page',
            visiteur: 'Modification of the visitor block',
            presentation: 'Modification of the presentation block',
            contact: 'Modification of the contact block',
            correspondant: 'Modification of the correspondent block'
        },
        fields: {
            title: 'Block title *',
            content: 'Bloc content'
        }
    },
    notify: {
        success: 'Treść została zapisana',
        error: 'Wystąpił błądAn error has occurred'
    },
    btn: {
        save: 'Zapisz',
        cancel: 'Anuluj'
    },
    global: {
        messages: {
            accueilFO: 'Wtyczka śledząca jest używana tymczasowo, aby umożliwić nam ulepszenie narzędzi w oparciu o Twoje użytkowanie.'
        },
        link: {
            viderFiltre: 'Wyczyść wszystkie kryteria'
        },
        buttons: {
            rechercher: 'Wyszukiwanie',
            voirPlus: 'Zobacz więcej...',
            annuler: 'Anuluj',
            confirm: 'Potwierdź',
            compris: 'Zrozumiałem',
            more: 'WIĘCEJ SZCZEGÓŁÓW',
            save: 'Zapisz',
            save_filter: 'Zapisz',
            send: 'Wyślij',
            close: 'Zamknij',
            add: 'Dodaj',
            validate: 'Uprawomocnić',
            loginGoogle: 'SIGN IN WITH GOOGLE'
        },
        errors: {
            droitsInsuffisants: 'Twój aktualny poziom dostępu nie pozwala na dostęp do tej strony',
            obligatoire: 'To pole musi być wypełnione',
            formulaire: 'Musisz wypełnić wymagane pola',
            formatEmail: 'Nieprawidłowy format wiadomości e-mail',
            amountObligatoire: 'Musisz wprowadzić walutę',
            amountObligatoireMontant: 'Musisz podać kwotę',
            emptyMessageError: ' '
        },
        yes: 'Tak',
        no: 'Nie',
        workInProgress: 'Roboty w toku',
        no_results: 'Brak wyników.',
        resultTitle: '{results, plural, one {wyniki} other {wyniki}} Wyszukiwanie ({results, number})',
        tris: {
            pertinence: 'Według trafności',
            a_z: 'A ⇒ Z',
            z_a: 'Z ⇒ A',
            date_connexion_desc: 'Daty ostatnich połączeń od najnowszego do najstarszego',
            date_connexion_asc: 'Daty ostatnich połączeń od najstarszego do najnowszego',
            date_modification_desc: 'Daty modyfikacji od najnowszej do najstarszej',
            date_modification_asc: 'Daty modyfikacji od najstarszej do najnowszej',
            like: 'Najbardziej lubiane treści'
        },
        more: {
            export_result: 'Eksportuj wyniki',
            partage_result: 'Udostępnij wyszukiwanie',
            ajouter_favoris_result: 'Dodaj wyszukiwanie do ulubionych',
            ajouter_favoris_result_notif_on: 'Dodaj wyszukiwanie do ulubionych z powiadomieniem'
        }
    },
    menu: {
        boParametrageMenu: 'KONFIGURACJA',
        boPropositionCommercial: 'Oferty',
        boSavoirFaire: 'Know-How',
        boReference: 'Referencje',
        boValueList: 'Zestawienie wartości',
        additionalFilters: 'Dodatkowe filtry',
        boPersonnalisationMenu: 'CUSTOMIZATION',
        boBlocPresentation: 'Presentation block',
        boBlocVisiteur: 'Visitor\'s block',
        boBlocContact: 'Contact block ',
        boBlocCorrespondant: 'Correspondent block',
        returnFo: 'Front office',
        admin: 'Functional Administration',
        accueilMenu: 'Strona główna',
        contenuMenu: 'SPIS TREŚCI',
        rechercherContenu: 'Szukaj treści',
        ajouterContenu: 'Dodaj treść',
        contribution: 'Moje zaangażowanie',
        contenuAValider: 'Treść do potwierdzenia',
        contenuAPublier: 'Treść do publikacji',
        contenuARetirer: 'ANG-Content to be removed',
        annuaireMenu: 'KATALOG',
        correspondanceZone: 'Korespondenci w Strefie',
        demandeAcces: 'Poproś o dostęp',
        demandeAttente: 'Wnioski oczekujące',
        listeUtilisateur: 'Lista użytkowników',
        aideContactMenu: 'POMOC I KONTAKT',
        presentationTenderBox: 'Prezentacja Tender Box',
        formContact: 'Skontaktuj się z zespołem obsługi Tender Box'
    },
    favoris: {
        addSearch: {
            success: 'Twoje wyszukiwanie zostało dodane do ulubionych',
            error: 'Wyszukiwanie nie mogło zostać dodane do ulubionych'
        },
        document: 'Spis treści',
        emptyDocument: 'Nie zapisałeś jeszcze żadnych treści w formie zakładek',
        search: 'Wyszukiwanie',
        emptySearch: 'Nie zarejestrowałeś jeszcze żadnego wyszukiwania',
        searchItem: 'Wyszukiwanie zapisane dnia',
        deleteSearchTitle: 'Usuwanie ulubionego wyszukiwania',
        deleteDocumentTitle: 'Usuwanie dokumentu z zakładką',
        deleteSearchDescription: 'Czy naprawdę chcesz usunąć to wyszukiwanie z ulubionych?',
        deleteDocumentDescription: 'Czy na pewno chcesz usunąć zawartość ulubionych?',
        updateSearch: {
            success: 'Wyszukiwanie zostało zaktualizowane',
            error: 'Wyszukiwanie nie mogło zostać zaktualizowane'
        },
        deleteSearch: {
            success: 'Wyszukiwanie zostało usunięte',
            error: 'Nie można usunąć wyszukiwania'
        }
    },
    appBar: {
        menus: {
            monCompte: 'Moje konto',
            cookies: '[ANG] Manage my cookies',
            logout: 'Wyloguj'
        }
    },
    accueilBo: {
        title: 'Welcome to administration'
    },
    translation: {
        inputLabel: 'Tłumaczenie',
        button: 'Tłumacz'
    },
    searchBar: {
        placeHolder: 'Przeszukaj Tender Box',
        all: 'Cała zawartość'
    },
    autocompleteMulti: {
        placeHolder: 'Wybierz',
    },
    constants: {
        request: {
            VALID: 'Potwierdzona',
            TO_VALIDATE: 'Do potwierdzenia'
        },
        profils: {
            VISITEUR: 'Gość',
            MEMBRE: 'Użytkownik',
            CORRESPONDANT: 'Korespondentów',
            ADMIN: 'Administrator'
        },
        user_connecte: {
            SEMAINE: 'W ciągu tygodnia',
            MOIS: 'W ciągu miesiąca',
            TRIMESTRE: 'w ciągu 3 miesięcy',
            ANNEE: 'W ciągu roku'
        }
    },
    users: {
        title: 'Wyszukiwanie',
        listeUsers: 'Lista użytkowników ',
        listeDemandes: 'Zgłoszenia do potwierdzenia ',
        listeCorrespondants: 'Menedżer',
        demandeCorrespondant: 'Chcesz zostać menedżerem?',
        click: 'Kliknij tutaj',
        noResults: 'Brak użytkowników pasujących do Twojego wyszukiwania',
        search: {
            filterTitle: 'Wyszukiwanie',
            default: 'Obojętny',
            nameLabel: 'Nazwisko',
            zoneLabel: 'Strefa',
            paysLabel: 'Kraj',
            paysOrigineLabel: 'Kraj pochodzenia',
            marcheLabel: 'Rynek',
            segmentLabel: 'Segment biznesowy',
            profilLabel: 'Profil',
            demandeLabel: 'Zgłoszenie',
            connecteLabel: 'Podłączeni użytkownicy'
        },
        export: {
            headers: {
                nom: 'ANG - Nom',
                prenom: 'ANG - Prénom',
                zone: 'ANG - Zone',
                statut: 'ANG - Statut',
                dateAjoutStatut: 'ANG - Date d\'ajout du statut',
                dateDerniereConnexion: 'ANG - Date de dernière connexion'
            },
            fileName: 'Export des utilisateurs'
        },
        actions: {
            valid: 'Potwierdź',
            donDroits: 'Przyznaj uprawnienia',
            refuse: 'Odrzuć',
            delDroits: 'Anuluj dostęp',
            modify: 'Modyfikuj konto użytkownika'
        },
        accesRequest: {
            demande: 'Prośba dostępu zgłoszona dnia: ',
            valide: 'Dostęp potwierdzony dnia: ',
            refuse: 'Odmowa dostępu: ',
            derniereCo: 'Ostatnie logowanie dnia: ',
            refusAuto: 'Odmowa automatyczna'
        },
        popin: {
            validation: {
                titlePopin: 'Przyznaj uprawnienia',
                messagePopin: 'Czy potwierdzasz przyznanie uprawnień dla ',
                success: 'Prośba o dostęp została potwierdzona.',
                error: 'Podczas weryfikacji prośby wystąpił błąd.'
            },
            refus: {
                titleRefus: 'Odrzuć prośbę o dostęp',
                titleRetire: 'Anuluj dostęp ',
                messageRefus: 'Czy potwierdzasz odrzucenie prośby o dostęp od ',
                messageRetire: 'Czy potwierdzasz anulowanie dostępu dla ',
                field: 'Uzasadnienie *',
                success: 'Wniosek o odmowę został zatwierdzony',
                error: 'Podczas przetwarzania wniosku o odmowę wystąpił błąd'
            }
        }
    },
    oss: {
        popinChoixFields: {
            title: 'Wybór kolumn do wyświetlenia ({sizeColumns}/50 kolumn maksymalnie)',
            sectionChampsAvances: 'Pola zaawansowane',
            maxColumnReached: 'Nie możesz wyświetlić więcej niż 50 kolumn w tabeli'
        },
        tooltip: {
            accesEditList: 'Edytuj referencje',
            accesViewList: 'Wizualizacja referencji badawczych'
        },
        tabDocumentPage: {
            titleEdition: 'Edycja treści',
            titleConsultation: 'Wizualizacja treści',
            table: {
                headerTitle: 'Bibliografia'
            },
            tooltip:{
                fieldNotFoundLang: 'To pole nie jest jeszcze wypełnione w wybranym języku, aby je wypełnić, przejdź bezpośrednio do referencji.',
                notEditable: 'To pole wpływa na strukturę referencji, aby ją zmodyfikować, przejdź bezpośrednio do referencji.',
                cantModify: 'To pole nie jest jeszcze wypełnione w wybranym języku, aby je wypełnić, przejdź bezpośrednio do referencji.',
                notExist: 'To pole nie jest wypełnione w żadnym z języków, aby je wypełnić, przejdź bezpośrednio do referencji.'
            },
            snackBar: {
                tabInfo: 'Ten tryb edycji pozwala zobaczyć tylko te referencje, do których masz uprawnienia do edycji.',
                editFieldSucces: 'Uwzględniona zmiana.',
                editFieldError: 'Edycja nie powiodła się.',
                tabModificationInfo: 'Ten tryb edycji pozwala zobaczyć tylko te referencje, do których masz uprawnienia do edycji.',
                tabConsultationInfo: 'Ten tryb wyświetlania umożliwia przeglądanie wszystkich referencji z wyjątkiem poufnych danych reprezentowanych przez *.'
            }
        },
        actionBar:{
            editColumns: 'Dodaj / usuń kolumny'
        },
        popin: {
            shareTitle: {
                title: 'Udostępnij tablicę'
            }
        }
    },
    document: {
        search: {
            collapse:{
                location: 'LOKALIZACJA',
                clients: 'KLIENCI',
                activities: 'DZIAŁANIA',
                document: 'RODZAJE DOKUMENTÓW',
                additional: 'DODATKOWE FILTRY',
                admin: 'ADMINISTRATOR FILTRÓW'
            },
            additionalInfos: 'Szukasz innego kryterium?',
            additionalAddInfos: 'Kliknij tutaj, aby wyszukać dane',
            adminInfos: 'Kliknij tutaj, aby dodać filtr administratora',
            correspondantInfos: 'Kliknij tutaj, aby dodać filtr korespondenta',
            title: 'Przeszukaj Tender Box',
            titleMesContrib: 'Moje zaangażowanie',
            titleAValider: 'Treść do potwierdzenia',
            titleAPublier: 'Treść do publikacji',
            titleARetirer: 'ANG - Content to withdraw',
            filterTitle: 'Kryteria wyszukiwania',
            default: 'Obojętny',
            queryPlaceholder: 'Przeszukaj Tender Box',
            typeContenuLabel: 'Rodzaje treści',
            typeContenuDefault: 'Wszystkie',
            langueLabel: 'Język',
            zoneLabel: 'Strefa',
            marketLabel: 'Rynek',
            sectorLabel: 'Sector',
            businessSegmentLabel: 'Segment biznesowy',
            businessSubSegmentLabel: 'Podsegment',
            coreBusinessLabel: 'Działalność podstawowa',
            bidBriefLabel: 'Część opisu oferty',
            paysLabel: 'Kraj',
            proposalStatusLabel: 'Status wniosku',
            withAttachmentLabel: 'Z załącznikami',
            internalExternalLabel: 'Wewnętrzna zewnętrzna',
            noResults: 'Brak treści pasujących do Twojego wyszukiwania',
            correspondant: {
                title: 'FILTR KORESPONDENTÓW',
                info: 'Po zastosowaniu jednego z poniższych filtrów, wyszukiwanie zostanie przeprowadzone z uwzględnieniem tylko tych treści wobec których jesteś korespondentem'
            },
            field: {
                noInput: 'Wprowadź wartość',
                noValue: 'Brak odpowiedniej wartości'
            },
            advance: {
                title: 'Filtry zaawansowane',
                addFilter: 'Dodaj filtr',
                description: 'Poniżej można wybrać rekomendowane filtry zaproponowane zgodnie z wybranymi podsegmentami. \n' +
                    'Jeśli szukasz innej konkretnej pozycji danych, wybierz opcję "<strong>Inne dane</strong>", która pozwala na wyszukanie konkretnej pozycji danych.',
                removeFilter: 'Wyczyść wszystkie filtry',
                showOnlyAttachments: 'Pokaż tylko treści z załącznikami',
                appliedFilters: 'Zastosowane filtry',
                appliedFiltersDescription: 'Tutaj pojawiają się dodatkowe zastosowane filtry',
                newFilter: {
                    title: 'Nowy filtr',
                    field: {
                        searchKey: 'Dodatkowy filtr',
                        searchNumber: 'Równe, wyższe lub niższe',
                        searchDate: 'Przed, Po',
                        searchText: 'Zawiera, nie zawiera',
                        placeholderText: 'Szukaj według wartości',
                        otherData: 'Wyszukaj inne dane',
                        dataName: 'Nazwa danych',
                        attachment: 'Pokaż tylko treści z załącznikami',
                        and: '{lessThan} oraz {greaterThan}',
                        EQUAL: 'Równy',
                        NOT_EQUAL: 'Różny od',
                        SUPERIOR: 'Wyższy niż',
                        INFERIOR: 'Niższy niż',
                        BEFORE: 'Przed',
                        AFTER: 'Po',
                        INCLUDE: 'Zawiera',
                        NOT_INCLUDE: 'Nie zawiera',
                        BETWEEN: 'Pomiędzy',
                        EQUAL_DATE: 'Ten ',
                        errorBetween: 'Nie może być mniejsza niż pierwsza wartość',
                        errorBetweenDate: 'Nie może być wcześniej niż pierwsza randka'
                    },
                    button: 'Filtr',
                    closeButton: 'Anuluj'
                }
            },
            adminPopin: {
                title: 'Filtry administratorów',
                description: 'Masz tutaj możliwość filtrowania informacji przeznaczonych dla administratorów, takich jak: status treści, współtwórcy, data utworzenia, data przesłania, data publikacji i inne.',
                fields: {
                    adminFilter: 'Filtr administratora'
                }
            },
            correspondantPopin: {
                title: 'Filtry korespondenta',
                description: 'Masz tutaj możliwość filtrowania informacji przeznaczonych dla korespondentów, takich jak: status treści, współtwórcy i inne. Po zastosowaniu filtru tutaj wyszukiwanie odbywa się tylko na podstawie treści, których jesteś korespondentem.',
                fields: {
                    correspondantFilter: 'Filtr korespondenta'
                },
                typeField: {}
            },
            adminCorrespondantPopin: {
                errors:{
                    date2Beforedate1 :'Nieprawidłowe daty'
                },
                fields: {
                    status: 'Status treści',
                    contributor: 'Kontrybutor',
                    dateCreation: 'Data utworzenia',
                    dateSoumission: 'Termin składania',
                    datePublication: 'Data publikacji',
                    publierPar: 'Administrator, który opublikował treść',
                    dateLastModif: 'Ostatnia modyfikacja',
                    modifierPar: 'Użytkownik ze zmodyfikowaną ostatnią treścią',
                    dateMasqued: 'Data usunięcia',
                    masquerPar: 'Administrator z usunietą treścią '
                },
                radioGroup: {
                    after: 'Po ',
                    at: 'Ten ',
                    before: 'Przed ',
                    between: 'Między '
                },
                appliedFilters: 'Zastosowane filtry',
                emptyStateFilters: 'Tutaj pojawiają się dodatkowe zastosowane filtry',
                cardTitle: {
                    status: 'Status',
                    contributor: 'Kontrybutor',
                    dateCreation: 'Utworzony',
                    dateSoumission: 'Złożony',
                    datePublication: 'Opublikowany',
                    publierPar: 'Opublikowany przez',
                    dateLastModif: 'Ostatnia modyfikacja',
                    modifierPar: 'Ostatnia modyfikacja',
                    dateMasqued: 'Zdjęty',
                    masquerPar: 'Ukryty przez'
                },
                filterDateBetween: 'Między {dateDebut} a {dateFin}'
            },
            share: {
                title: 'Udostępnij wyszukiwanie',
                description: 'Wpisz adresy e-mail odbiorców oddzielone znakiem ";" w celu udostępnienia im wykonanego przez Ciebie wyszukiwania  ',
                form: {
                    email: 'E-mail odbiorcy',
                    commentaire: 'Komunikat dodatkowy'
                },
                success: 'Twoje wyszukiwanie zostało udostępnione'
            },
            export: {
                sent: 'Twoje wyszukiwanie jest obecnie eksportowane. Otrzymasz e-mail z potwierdzeniem że dokument jest już dostępny.',
                title: 'Eksportuj tabelę wyników',
                description: 'Masz zamiar wyeksportować wyniki wyszukiwania. W tym miejscu możesz wybrać kolumny które będą widoczne w tabeli i uporządkować je według własnego uznania',
                selection: 'Wybór kolumn',
                selected: 'Wybrane kolumny',
                default: 'Kolumny domyślne',
                add: 'Dodaj',
                remove: 'Usuń',
                placeholder: 'Kolumny do wyeksportowania',
                send: 'Tabela eksportowana'
            },
            notFound: 'Do podanego identyfikatora nie pasuje żadne wyszukiwanie',
            addToFavorite: {
                title: "Edycja zapisanego wyszukiwania",
                form: {
                    title: "Tytuł wyszukiwania",
                    notification: "Cotygodniowe monitorowanie"
                }
            }
        },
        card: {
            created: 'Utworzono dnia: ',
            contributor: 'Autor: ',
            modified: 'Zaktualizowano dnia: ',
            modifiedBy: 'Zaktualizował(a):  ',
            submit: ' Przesłano dnia: ',
            submitBy: 'Przesłał(a): ',
            validated: 'Potwierdzono dnia:  ',
            published: 'Opublikowano dnia:',
            publishedBy: 'Opublikował(a):  ',
            masked: 'Ukryto dnia: ',
            maskedBy: 'Ukrył(a): ',
            toDelete: 'ANG - Requested suppression the: ',
            toDeleteBy: 'ANG - Requested deletion by : ',
            toMask: 'ANG - Request masked the: ',
            toMaskBy: 'ANG - Request masked by : '
        },
        newDocumentPage: {
            propositionCommercial: {
                titre: 'Proposal',
                description: 'Rodzaj oferty umożliwia udostępnianie informacji i dokumentów przekazanych klientowi w ramach Tender Box. \nNiektóre dane mogą zostać uznane za poufne i w związku z tym będą niewidoczne dla większości użytkowników Tender Box ',
                libelleLien: 'DODAJ OFERTĘ'
            },
            savoirFaire: {
                titre: 'Know-how',
                description: 'Treści typu know-how umożliwiają udostępnianie konkretnych informacji związanych z know-how Veolii i ponowne ich wykorzystywanie w ofertach lub w raportach.',
                libelleLien: 'DODAJ KNOW-HOW'
            },
            reference: {
                titre: 'Referencje',
                description: 'Treści typu referencyjnego umożliwiają udostępnianie danych handlowych i technicznych dotyczących projektów Veolia. Niektóre dane mogą zostać uznane za poufne i w związku z tym będą niewidoczne dla większości użytkowników Tender Box',
                libelleLien: 'DODAJ Referencje'
            }
        },
        submittingInfo: 'Ze względu na ograniczenia Google w zakresie kopiowania, wczytywanie folderów oraz plików może potrwać kilka minut. Nie zamykaj tej karty przed zakończeniem zapisywania.',
        saveSuccess: 'Dane zostały zapisane. Niniejszy zapis i jego prezentacja w Tender Box może chwilę potrwać, w zależności od liczby i rozmiaru załączników.',
        newContent: 'Nowa treść  ',
        editContent: 'Modyfikacja treści',
        retour: 'Zwrot',
        saveRequiredPublication: 'Zmiana statusu wymaga rejestracji',
        saveRequired: 'Zmiana języka wymaga rejestracji',
        errorField: 'Pole “{fieldName}” musi być prawidłowo wypełnione',
        globalReport: {
            tooltip: 'Zaktualizuj wartości Raportu Globalnego',
            popin: {
                title: 'Zaktualizuj ten arkusz',
                details: 'Niektóre  pola danych powiązane są z repozytorium danych Veolia Global Report. Masz zamiar zaktualizować pola poprzez wprowadzenie bieżącychi danych z Raportu Globalnego, co spowoduje usunięcie wartości widocznych wcześniej w tych polach.',
                confirm: 'Aktualizacja'
            },
            success: "Aktualizacja wartości związanych z Raportem Globalnym została zakończona"
        },
        entete: {
            title: 'Tytuł',
            zone: 'Strefa',
            language: 'Język oryginalny',
            contributor: 'Autor',
            commentaire: 'Uwaga do zespołu obsługi Skrzynki Ofertowej (niepublikowany)'
        },
        section: {
            defaultTitle: 'Tytuł sekcji',
            defaultSubtitle: 'Podtytuł sekcji',
            switch: 'Oznacz tą sekcję jako zakończoną',
            deleteTitle: 'Usuń powieloną sekcję',
            deleteMessage: 'Czy potwierdzasz usunięcie tej powielonej sekcji?'
        },
        field: {
            confidentiable: 'Dane poufne',
            libelleLink: 'Pisowania',
            urlLink: 'URL',
            defaultValueInfo: 'Wartość referencyjna w bazie danych:',
            noValueInGR: 'Brak danych referencyjnych dla tego pola.',
            drive: {
                formPlaceHolder : "Przeszukaj drive",
                open: 'Otwórz mój dysk',
                selectFiles: 'Wybierz odpowiednie pliki z dysku',
                infoFolder: 'Tylko pięć pierwszych poziomów danego katalogu zostanie zaimportowanych. Podkatalogi i pliki poniżej poziomu piątego nie zostaną zaimportowane. Maksymalny rozmiar importowanego pliku to 50 MB (brak limitu rozmiaru plików wideo).',
                prefixFolder: 'Katalog :',
                errorRights: '{nomFichier} nie pobrano (brak autoryzacji).',
                errorSize: '{nomFichier} nie pobrano  (maksymalny rozmiar 50MB).',
                errorGlobal: '{nomFichier}  nie pobrano (wystąpił błąd).',
                uploading: '- Zapis w toku ...'
            },
            duns:{
                noresult:"Brak wyników",
                errorApi:"Błąd wywołania API Dunsa",
                dunsLabelName:"Nazwa firmy",
                dunsGlobalLabelName:"Firma macierzysta (świat)",
                dunsCountryLabelName:"Firma macierzysta (kraj)",
                searchLink:"Potrzebujesz pomocy, aby znaleźć kod DUNS?"
            }
        },
        folderPopin: {
            title: 'Kompozycja plików z polem "{fieldName}"',
            emptyFolder: 'Katalog jest pusty',
            emptySearch: 'Żaden dokument nie pasuje do wyszukiwania'
        },
        statusResponse: {
            error: 'Nie masz uprawnień do wykonania tej czynności.',
            refus: 'ANG - La demande a bien été refusée.',
            A_VALIDER: 'Treść została przesłana.',
            VALIDE: 'Treść została potwierdzona.',
            PUBLIE: 'Treść została opublikowana.',
            MASQUE: 'Treść została usunięta.',
            SUPPRIME: 'ANG - The content has been deleted.',
            A_SUPPRIMER: 'ANG - The content has been submitted to be deleted.',
            A_MASQUER: 'ANG - The content has been submitted to be masked.'
        },
        button: {
            soumettre: 'Prześlij',
            valider: 'Potwierdź',
            publier: 'Publikuj',
            retirer: 'Usuń'
        },
        menuConsultation: {
            share: 'Udostępnij',
            save: 'Zarejestruj',
            contribute: 'Przyczynianie się',
            exportFollow: 'Eksport w celu dalszych działań'
        },
        partage: {
            title: 'Udostępnij treści',
            ask: 'Czy chcesz udostępnić te treści w celu konsultacji lub uzupełnienia?',
            description: 'Wpisz adresy e-mail odbiorców oddzielając je znakiem ";" w celu udostępnienia im linku do treści.',
            form: {
                contribution: 'Udostępnij w celu uzupełnienia',
                consultation: 'Udostępnij w celu konsultacji',
                email: 'Adres e-mail odbiorcy(-ów)*',
                commentaire: 'Wiadomość dodatkowa'
            },
            success: 'Treść została pomyślnie udostępniona',
            close: 'Zamknij',
            send: 'Wyślij'
        },
        translate: {
            title: 'Tłumaczenie automatyczne',
            ask: 'Wybierz język w którym ma zostać wykonane automatyczne tłumaczenie.',
            description: 'Automatyczne tłumaczenie zostanie wykonane tylko dla pól które są niewypełnione w wybranym języku (językach), a użytkownik będzie mógł w każdej chwili je zmodyfikować.',
            close: 'Anuluj',
            send: 'Tłumacz'
        },
        suivi: {
            success: 'Eksport jest w toku, otrzymasz wiadomość e-mail z linkiem umożliwiającym dostęp do pliku.'
        },
        masquerSupprimerDoc: {
            popin: {
                title: 'ANG - Request for withdrawal of content',
                detailsBrouillonOrToValidate: 'ANG - Since this content is not published yet, it can only be deleted definitively. Do you want to delete it?',
                details: 'ANG - Do you want to ask to hide this tender box content or delete it permanently?',
                titleAdmin: 'ANG - Remove the contents',
                detailsAdmin: 'ANG - Do you want to hide this contents of Tender Box or delete it permanently?',
                detailsMsg: 'ANG - You can add a message to the administrator.',
                placeholder: 'ANG - Complementary message (250 characters max.) *',
                warningSuppression: 'ANG - CAUTION: The suppression is irreversible',
                demandExistMasque: 'ANG - A user wants to hide this sheet.',
                demandExistSuppression: 'ANG - A user wants to remove this sheet.',
                messageUserForAdmin: 'ANG - User\'s message: {message}',
radioGroup: {
    retrait: 'ANG - Hide this content',
        suppression: 'ANG - Delete definitely',
        rollBackToPublie: 'ANG - Cancel the current application'
}
},
snackbar: {
    success: 'ANG - Request for withdrawal taken into account',
        error: 'ANG - An error has occurred'
}
}
},
contact: {
    title: 'Skontaktuj się z zespołem obsługi Tender Box',
        validation: {
        message: 'Twoja wiadomość została pomyślnie wysłana, zespół obsługi Tender Box odpowie na nią możliwie jak najszybciej.'
    },
    field: {
        sujet: {
            label: 'Temat *',
                placeholder: 'Wybierz temat wiadomości'
        },
        objet: 'Obiekt *',
            message: 'Komunikat *'
    }
},
enums: {
    langue: {
        fr: 'Francuski',
            en: 'Angielski',
            es: 'Hiszpański',
            pl: 'Polski'
    },
    documentType: {
        REFERENCE: 'Referencje',
            PROPOSITION_COMMERCIALE: 'Oferty',
            SAVOIR_FAIRE: 'Know-how'
    },
    profil: {
        ROLE_VISITEUR: 'Gość',
            ROLE_MEMBRE: 'Użytkownik',
            ROLE_CORRESPONDANT: 'Korespondentów',
            ROLE_ADMIN: 'Administrator'
    },
    documentStatus: {
        BROUILLON: 'Wersja robocza',
            A_VALIDER: 'Do potwierdzenia',
            VALIDE: 'Potwierdzona',
            PUBLIE: 'Opublikowana',
            MASQUE: 'Ukryta',
            A_SUPPRIMER: 'ANG - To delete',
            A_MASQUER: 'ANG - To mask'
    },
    documentStatusSummary: {
        BROUILLON: '(Wersja robocza)',
            A_VALIDER: '(do potwierdzenia)',
            VALIDE: '(Potwierdzona)',
            PUBLIE: '(Opublikowana)',
            MASQUE: '(Ukryta)',
            A_SUPPRIMER: 'ANG - (to delete)',
            A_MASQUER: 'ANG - (to hide)',
            SUPPRIME: 'ANG - Deleted'
    },
    documentStatusContributions: {
        BROUILLON: 'Utworzono dnia:',
            A_VALIDER: 'Przesłano dnia:  ',
            VALIDE: 'Potwierdzono dnia:  ',
            PUBLIE: 'Opublikowano dnia:',
            MASQUE: 'Anulowano publikację dnia:',
            A_SUPPRIMER: 'ANG - [SUP] submitted the',
            A_MASQUER: 'ANG - [Mask] submitted the'
    },
    field: {
        TEXT: 'Tekst',
        TEXT_MULTILINE: 'Treść wielowierszowa',
        SELECT: 'Wybierz',
        MULTI_SELECT: 'Wybór wielokrotny',
        NUMBER: 'Numer',
        NUMBER_UNIT: 'Numer i jednostka',
        AMOUNT: 'Kwota',
        DATE: 'Data',
        FILE: 'Plik',
        LINK: 'Link',
        LINK_PROPOSITION: 'Link do oferty',
        TABLE: 'Tabela',
        DUNS: 'TODO-ANG : Code Duns'
    },
    withAttachment:{
        CASE_STUDY: 'Studium przypadku',
            CERTIFICATE: 'Certyfikat'
    },
    internalExternal: {
        INTERNAL: 'Wewnętrzny',
            EXTERNAL: 'Zewnętrzny'
    }
},
modificationUser: {
    title: 'użytkownik:',
        titleCompte: 'Moje konto',
        retour: 'Powrót do wyszukiwania',
        infoVisiteur: 'Jako Gość masz ograniczony dostęp do Tender Box.\n' +
    'Użytkownik może uzyskać dostęp do wielu dodatkowych funkcji, takich jak:\n' +
    '-rozszerzanie treści dotyczących Twojego regionu wprowadzając dane do Tender Box\n' +
    '-udostępnianie swoich kryteriów wyszukiwania\n' +
    '-zapisywanie swoich ulubione informacji',
        btnAsk: 'Poproś o dostęp',
        form: {
        titlePart: 'Preferencje',
            nom: 'Nazwisko *',
            prenom: 'Imię *',
            email: 'E-mail *',
            zone: 'Strefa *',
            zoneVisiteur: 'Upewnij się, że wprowadziłeś nazwę swojego kraju. W momencie zgłoszenia prośby o dostęp, jego modyfikacja nie będzie możliwa i tylko administrator będzie mógł go edytować',
            profil: 'Profil *',
            FI_COUNTRY: 'Kraj',
            FI_PRE_CLIENT_MARKET: 'Rynek',
            FI_SEGMENTS: 'Segment biznesowy',
            FI_PRE_CLIENT_SECTOR: 'Sector',
            FI_SUBSEGMENT: 'Podsegment',
            paysOrigine: 'Kraj pochodzenia *',
            langue: 'Język *',
            devise: 'Waluta *',
            su: 'System jednostkowy *',
            paramGestion: 'Zarządzanie parametrami',
            paramSubElement: 'Zarządzanie facylitatorem',
            error: {
            mandatory: 'To pole musi być wypełnione'
        }
    },
    backHome: 'Powrót do strony głównej',
        askTitle: 'Poproś o dostęp',
        askMessage: 'Twoja prośba została wysłana. W momencie potwierdzenia lub odmowy dostępu przez menedżera Twojego BU, otrzymasz odpowiednie powiadomienie drogą mailową.',
        popin: {
        title: 'Edycja profilu i preferencji',
            message: 'Czy potwierdzasz wprowadzone modyfikacje wobec profilu ',
            success: 'Dane użytkownika zostały zmienione.',
            error: 'Podczas rejestracji użytkownika wystąpił błąd.'
    }
},
accueil: {
    propositionCommerciale: {
        titre: 'Oferty',
            description: 'Rodzaj treści oferty umożliwia udostępnianie informacji i dokumentów przekazanych klientowi w ramach oferty.'
    },
    savoirFaire: {
        titre: 'Know-how',
            description: 'Treści typu know-how umożliwiają udostępnianie określonych i anonimowych informacji na temat know-how Veolii i ponowne ich wykorzystywanie w ofertach. '
    },
    reference: {
        titre: 'Referencje',
            description: 'Treści typu referencyjnego umożliwiają udostępnianie danych handlowych i technicznych dotyczących projektów Veolia.',
            button: 'Wyświetlaj tylko referencje ze studiami przypadków'
    },
    disponible: 'Dostępne w Tender Box',
        publication: 'Opublikowane w tym miesiącu',
        contenuAValider: {
        titre: 'Treść do potwierdzenia',
            description: 'TNiniejsze treści zostały przesłane przez uzytkowników Tender Box z Twojego regionu. Czekają one na Twoje potwierdzenie.',
            emptyTitre: 'Nie masz żadnych treści do potwierdzenia...',
            emptyDescription: 'Tutaj możesz zobaczyć liczbę treści przesłanych przez uzytkowników Tender Box z Twojego regionu, które czekają na Twoje potwierdzenie',
            bouton: 'Przeglądaj te treści'
    },
    contenuAPublier: {
        titre: 'Treść do publikacji',
            description: 'Niniejsze treści zostały przesłane przez członków Skrzynki Ofertowej z każdego regionu. Czekają one na opublikowanie Twojego potwierdzenia',
            emptyTitre: 'Nie masz żadnych treści do potwierdzenia...',
            emptyDescription: 'Tutaj możesz zobaczyć liczbę treści przesłanych przez uzytkowników Tender Box z każdego regionu, które czekają na opublikowanie potwierdzenia',
            bouton: 'Przeglądaj te treści'
    },
    accesAValider: {
        titre: 'Prośby o dostęp do potwierdzenia',
            description: 'Następujące prośby o dostęp zostały przesłane przez gości Tender Box z Twojego regionu. Potwierdź ich prośby by umożliwić im dostęp do treści i dać im pełny dostęp do Skrzynki Ofertowej.',
            emptyTitre: 'Nie masz autoryzacji do potwierdzenia ...',
            emptyDescription: 'Tutaj możesz zobaczyć liczbę próśb zgłoszonych przez gości Tender Box z Twojego regionu, które czekają na potwierdzenie',
            bouton: 'Przeglądaj te prośby'
    },
    accesAValiderAdmin: {
        titre: 'Prośby o dostęp do potwierdzenia',
            description: 'These access requests has been submitted by Tender Box visitors in every area. They are waiting for validation by the area managers.',
            emptyTitre: 'Nie masz autoryzacji do potwierdzenia ...',
            emptyDescription: 'Here you will find the number of requests asked by Tender Box visitors in every area, waiting for validation',
            bouton: 'Zobacz zapytania '
    },
    top: {
        titre: '10 najlepszych treści Tender Box',
            description: 'Lista 10 treści najbardziej lubianych przez danego użytkownika'
    },
    mesContributions: {
        titre: 'Moje zaangażowanie',
            description: 'Wszystkie dostarczone przeze mnie treści',
            add: 'Dodaj treść',
            empty: 'Nie przesłałeś żadnych treści'
    },
    libelleLien: {
        presentation: 'Dowiedz się więcej',
            contact: 'Nowa wiadomość',
            correspondant: 'Wyszukiwanie',
            visiteur: 'Poproś o dostęp'
    }
},
parametrage: {
    typeContenu: {
        PROPOSITION_COMMERCIALE: 'Oferty',
            SAVOIR_FAIRE: 'Know-how',
            REFERENCE: 'Referencje'
    },
    plan: 'Plan',
        detail: 'Detail',
        section: {
        defaultTitle: 'Section title',
            type: {
            FI: 'Identity card',
                RUBRIQUE: 'Nagłówek',
                STANDARD: 'Standard',
                DOCUMENT: 'Dokument'
        },
        level: 'level {level}',
            form: {
            REFERENCE: "References : ",
                new: 'New level 1 section',
                title: 'References: new section',
                parent: 'Parent Section *',
                name: {
                en: 'Section name (English) *',
                    fr: 'Section name (French) *',
                    es: 'Section name (Spanish) *',
                    pl: 'Section name (Polish) *'
            },
            type: 'Section type*',
                titleCode: 'Kod pola mający wpływ na tytuł',
                after: 'The section appears after the section*',
                first: 'The section is displayed in first position',
                visibility: 'The section\'s visibility is conditioned by a value',
                reference: 'Reference of the data conditioning the visibility',
                code: 'Value code conditioning visibility',
                publier: 'Publish section',
                traduction: 'Translation'
        },
        createsuccess: 'New section successfully created',
            editsuccess: 'Section successfully modified',
            delete: {
            title: 'Delete section',
                ask: 'Are you sure you want to delete this section?',
                success: 'Section deleted successfully',
                error: {
                child: 'Unable to delete because the section is not empty.',
                    fi: 'You can\'t delete the identity card.',
                    generic: 'An error occurred while deleting the section.'
            }
        },
        error: {
            isNotEmpty: 'Unpublication not possible because the section contains data / sections that are not unpublished',
                parentNotPublished: 'Unable to publish because parent section is unpublished'
        }
    },
    field: {
        defaultTitle: 'Field title'
    },
    btnSection: 'New section',
        btnField: 'New data',
        btnMajSearch: 'Update search',
        majSearchSuccess: 'Search update in progress',
        updateOrder: {
        success: 'The data\'s position in the section has been updated'
    },
    deleteField: {
        popin: {
            title: 'Data deletion {name}',
                content: 'Are you sure you would like to delete the data {name} ?'
        },
        error: {
            isReferenced: 'Unable to delete, because the data is referenced by the following data:<br />{references}',
                generic: 'An error occurred while deleting the data.'
        }
    },
    donneeForm: {
        newTitle: 'New data',
            fields: {
            sectionParent: 'Parent section',
                nomDonnee: 'Data\'s name ({langue})',
                reference: 'Data reference name',
                type: 'Data type',
                visibility: {
                check: 'The visibility of the data is conditioned by a value',
                    reference: 'Reference name of the data conditioning visibility',
                    code: 'Value code conditioning visibilityé'
            },
            defaut: 'Default value',
                confidentiable: 'The user can declare this data confidential',
                help: 'Help text for contributor({langue})',
                publier: 'Publish the data',
                select: {
                source: 'Origin of the value list',
                    reference: 'The content of this list depends on another data',
                    referenceParent: 'Reference name of the parent data'
            },
            unite: {
                source: 'Associated SI unit',
            default: 'Default unit'
            },
            table: {
                columnName: 'Column name ({langue})',
                    popin: {
                    addTitle: 'Add a column',
                        editTitle: 'Edit a column'
                }
            }
        },
        fieldTypes: {
            TEXT: 'Text',
                TEXT_MULTILINE: 'Multiline text',
                SELECT: 'Simple select',
                MULTI_SELECT: 'Multiple select',
                NUMBER: 'Number',
                NUMBER_UNIT: 'Number and unit',
                AMOUNT: 'Amount',
                DATE: 'Date',
                FILE: 'Document',
                LINK: 'Link',
                LINK_PROPOSITION: 'Link to another content',
                TABLE: 'Table',
                DUNS: 'TODO-ANG : Code Duns'
        },
        error: {
            isReferenced: 'Unpublication impossible, because the data is referenced by the following data:<br />{references}',
                parentNotPublished: 'Unable to publish because the parent section is not published',
                referenceAlreadyExist: 'This reference name already exists',
                tableReferenceIdentical: 'The table has identical references'
        }
    },
    traduction: 'Translation'
},
additionalFilters: {
    title: "Dodatkowe filtry",
        researchSections: 'Przeszukaj sekcję',
        researchFields: 'Kryteria wyszukiwania',
        newSection: 'Nowa sekcja',
        updateSection: 'Edytuj sekcję',
        newField: 'Nowe pole',
        updateField: 'Edycja kryteriów',
        reset: 'Anuluj',
        save: 'Zarejestruj',
        addField: 'Dodaj kryteria',
        form: {
        name: 'Nazwa sekcji (angielski)',
            subSegments: 'Wartość podsegmentu warunkująca widoczność',
            publishedSection: 'Opublikuj sekcję',
            publishedField: 'Pole publikacji',
            nameFr: 'Nazwa sekcji (francuski)',
            nameEs: 'Nazwa sekcji (hiszpański)',
            namePl: 'Nazwa sekcji (polski)',
            reference: 'Dane referencyjne',
            alreadyUsedReference: 'Ten kod jest obecnie używany w sekcji szukania',
            referenceNotFound: 'Nie znaleziono referencji'
    },
    add: {
        snackSuccess: 'Zmiany zapisane'
    }
},
valueList: {
    recherche: 'Search',
        valeurs: 'Value',
        form: {
        name: 'Name',
            shortcut: 'Code',
            description: 'Description'
    },
    entries: {
        valeurs: 'Value',
            actif: 'Active',
            inactif: 'Inactive'
    },
    popin: {
        add: 'Add a value',
            edit: 'Edit a value',
            code: 'Code',
            inactif: 'Inactive',
            langue: 'Label {codeLang}'
    }
}
})
